$(function () {
    var $breadcrumbtail = $('.js-breadcrumb-tail');
    var navigation_available = $(".navigation-global");
    var $window = $(window);
    var widthMobile = 992;

    //JD - This code only needs to run if the FAN protected indicator is present, so maybe one fewer binding to window scrolling is a good idea.
    if($breadcrumbtail.length && navigation_available.length) {
        //JD - on mobile, default to not visible and only show if a header is actually present, if there is no header there isn't really a correct place to put it!
        $(".breadcrumb-tail-panel").addClass("breadcrumb-tail-panel--visible");

        $window.scroll(function () {
            var y = $(this).scrollTop();

            var headerOffsetTop = $(this).getHeaderTopOffset();

            if ($window.width() > widthMobile) {
                if (y > headerOffsetTop) {
                    $breadcrumbtail.addClass('breadcrumb-tail--fixed');
                } else {
                    $breadcrumbtail.removeClass('breadcrumb-tail--fixed');
                }
            }
        });

        $window.scroll();
    }

});
